module.exports = __webpack_public_path__ + "images/f18e4946e29648613a09cdc342a25dbc.svg";